import type { ComponentProps, ReactNode } from 'react'
import type { View } from 'react-native'

export type GradientProps = {
  colors: string[]
  start?: { x: number; y: number } // от 0 до 1
  end?: { x: number; y: number }
  locations?: number[]
  children?: ReactNode
  pointerEvents?: ComponentProps<typeof View>['pointerEvents']
  style?: ComponentProps<typeof View>['style']
}

// Собирает CSS linear-gradient из цветов, направления и позиций остановок.
export function buildLinearGradient(
  colors: string[],
  start: { x: number; y: number },
  end: { x: number; y: number },
  locations?: number[],
) {
  const angle = Math.round((Math.atan2(end.y - start.y, end.x - start.x) * 180) / Math.PI + 90)
  const stops = colors
    .map((color, index) => {
      const position = locations?.[index] ?? index / Math.max(colors.length - 1, 1)
      return `${color} ${Math.round(position * 100)}%`
    })
    .join(', ')

  return `linear-gradient(${angle}deg, ${stops})`
}
